import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
  StakeholderReferenceStoreActions,
  StakeholderReferenceStoreSelectors,
  StakeholderReferenceStoreReducer,
  StakeholderReferenceGroupStoreReducer,
  StakeholderReferenceGroupStoreSelectors,
} from "./index";
import { CountryDto } from "@cradua/data";

@Injectable()
export class StakeholderReferenceFacade {
  constructor(
    private store: Store<
      StakeholderReferenceStoreReducer.StakeholderReferencePartialState
    >,
    private groupstore: Store<
      StakeholderReferenceGroupStoreReducer.StakeholderReferenceGroupPartialState
    >,
  ) {}

  stakeholderreferenceRecord$ = this.store.select(
    StakeholderReferenceStoreSelectors.getSelected,
  );
  stakeholderreferenceRecordError$ = this.store.select(
    StakeholderReferenceStoreSelectors.getStakeholderReferenceError,
  );

  getselected() {
    return this.store.select(StakeholderReferenceStoreSelectors.getSelected);
  }

  get isLoadingStakeholderReference() {
    this.store.dispatch(
      StakeholderReferenceStoreActions.loadStakeholderReference(),
    );
    return this.store.select(
      StakeholderReferenceStoreSelectors.loadingStakeholderReference,
    );
  }

  get loadStakeholderReference() {
    this.store.dispatch(
      StakeholderReferenceStoreActions.loadStakeholderReference(),
    );
    return this.store.select(
      StakeholderReferenceStoreSelectors.getAllStakeholderReference,
    );
  }

  isLoadingByTypeStakeholderReference(
    type: string,
    countryId: string,
    stakeholdergroupId: string,
  ) {
    this.store.dispatch(
      StakeholderReferenceStoreActions.loadByTypeStakeholderReference({
        reftype: type,
        countryId,
        stakeholdergroupId,
      }),
    );
    return this.store.select(
      StakeholderReferenceStoreSelectors.loadingByTypeStakeholderReference,
    );
  }

  loadByTypeStakeholderReference(
    type: string,
    countryId: string,
    stakeholdergroupId: string,
  ) {
    this.store.dispatch(
      StakeholderReferenceStoreActions.loadByTypeStakeholderReference({
        reftype: type,
        countryId,
        stakeholdergroupId,
      }),
    );
    return this.store.select(
      StakeholderReferenceStoreSelectors.getAllByTypeStakeholderReference,
    );
  }

  isLoadingByTypeStakeholderReferenceGroup(
    type: string,
    countryId: string,
    stakeholdergroupId: string,
  ) {
    this.store.dispatch(
      StakeholderReferenceStoreActions.loadByTypeStakeholderReferenceGroup({
        reftype: type,
        countryId,
        stakeholdergroupId,
      }),
    );
    return this.groupstore.select(
      StakeholderReferenceGroupStoreSelectors
        .loadingByTypeStakeholderReferenceGroup,
    );
  }

  loadByTypeStakeholderReferenceGroup(
    type: string,
    countryId: string,
    stakeholdergroupId: string,
  ) {
    this.store.dispatch(
      StakeholderReferenceStoreActions.loadByTypeStakeholderReferenceGroup({
        reftype: type,
        countryId,
        stakeholdergroupId,
      }),
    );
    return this.groupstore.select(
      StakeholderReferenceGroupStoreSelectors
        .getAllByTypeStakeholderReferenceGroup,
    );
  }

  addStakeholderReference(newStakeholderReference: any[], reftype: string) {
    this.store.dispatch(
      StakeholderReferenceStoreActions.addStakeholderReference({
        newStakeholderReference,
        reftype,
      }),
    );
  }

  updateStakeholderReference(
    updateStakeholderReference: any[],
    reftype: string,
  ) {
    this.store.dispatch(
      StakeholderReferenceStoreActions.updateStakeholderReference({
        updateStakeholderReference,
        reftype,
      }),
    );
  }

  removeStakeholderReference(ids: string[], reftype: string) {
    this.store.dispatch(
      StakeholderReferenceStoreActions.removeStakeholderReference({
        ids,
        reftype,
      }),
    );
  }
}
